import getDealerSupplierApi from '@/api/get/dealer/get-dealer-suppliers';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import PricingAllWrapper from '@/components/pages/pricing-all-wrapper';
import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import { APP_CONTEXT } from '@/utils/context';
import { Heading2Text } from '@/utils/global-fonts';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Styled from './pricing-all-style';

const noWhiteSpace = { whiteSpace: 'nowrap' };

/**
 * Page that shows all Dealer Pricing in a table format.
 * @returns {JSX.Element} The rendered Dealer Pricing Management page component.
 */
const DealerPricingAll = () => {
  const { currentUser } = useContext(APP_CONTEXT);
  const [suppliersLoading, setSuppliersLoading] = useState(true);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const { formState } = useForm();

  useEffect(() => {
    if (currentUser?.company_id) {
      getDealerSupplierApi(currentUser?.company_id).then((response) => {
        const suppliers = response?.data?.suppliers?.map((d) => ({
          value: d.id,
          label: d.name,
        }));
        setSupplierOptions(suppliers);
        setSuppliersLoading(false);
      });
    }
  }, [currentUser?.company_id]);

  return (
    <PageWrapper>
      <Styled.MainContainer>
        <FormWrapper defaultValues={{}} onSubmit={() => {}}>
          <Styled.Heading>
            <Heading2Text style={noWhiteSpace}>
              Price list Management
            </Heading2Text>
            <Styled.SupplierSelectDiv>
              <SelectSearch
                cy="selSupplierPriceList"
                name="supplier"
                label="Selected Supplier"
                placeholder="Please select a supplier"
                options={supplierOptions}
                required={{
                  required: 'Please select a supplier',
                  onChange: (e) => {
                    setSelectedSupplier(e.target.value);
                  },
                }}
                isLoading={suppliersLoading || formState.isLoading}
              />
            </Styled.SupplierSelectDiv>
          </Styled.Heading>
        </FormWrapper>
        <PricingAllWrapper isDealer companyId={selectedSupplier} />
      </Styled.MainContainer>
    </PageWrapper>
  );
};

export default DealerPricingAll;
